import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const faqs = [{
  q: '¿Cómo recibo el Mega Pack? ¿Me llega por correo?',
  a: '<strong class="text-brand-brown">No necesitás esperar ningún envío.</strong> En cuanto completás el pago recibís acceso inmediato a todos los tomos y bonos en formato digital. Podés empezar a ver el contenido en minutos desde tu teléfono, tablet o computadora.'
}, {
  q: '¿Sirve si soy principiante total y nunca hice un jabón?',
  a: 'Sí, fue diseñado exactamente para eso. El Mega Pack parte desde cero absoluto — <strong class="text-brand-brown">no asume ningún conocimiento previo.</strong> Si podés seguir una receta de cocina, podés hacer jabones artesanales con este sistema.'
}, {
  q: '¿Es un pago único o voy a tener cargos mensuales?',
  a: 'Es un <strong class="text-brand-brown">pago único de $14.99 y el acceso es tuyo de por vida.</strong> Sin suscripciones, sin renovaciones, sin sorpresas en tu tarjeta. Una sola vez y el material queda en tu cuenta para siempre.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-14 px-4 bg-white" data-id="element-85">
      <div className="max-w-3xl mx-auto" data-id="element-86">
        <div className="text-center mb-8" data-id="element-87">
          <h2 className="text-3xl md:text-4xl font-black mb-3 tracking-tight" data-id="element-88">
            ¿Todavía tenés dudas?
          </h2>
          <p className="text-xl text-brand-brown/80 font-playfair italic" data-id="element-89">
            Preguntas Frecuentes
          </p>
        </div>

        <div className="space-y-3 mb-12" data-id="element-90">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className={`border-2 rounded-xl overflow-hidden transition-all duration-300 ${isOpen ? 'border-brand-green bg-brand-green/5 shadow-md' : 'border-brand-brown/10 bg-white hover:border-brand-green/50'}`} data-id="element-91">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full text-left px-5 py-4 flex items-center justify-between gap-4 focus:outline-none" data-id="element-92">
                  <span className="font-black text-lg pr-6 font-playfair leading-tight" data-id="element-93">
                    {faq.q}
                  </span>
                  <div className={`shrink-0 w-9 h-9 rounded-full flex items-center justify-center transition-colors duration-300 ${isOpen ? 'bg-brand-green text-white' : 'bg-brand-cream text-brand-green'}`} data-id="element-94">
                    <ChevronDownIcon className={`w-5 h-5 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-95" />
                  </div>
                </button>

                <AnimatePresence data-id="element-96">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-97">
                      <div className="px-5 pb-5 text-brand-brown/80 text-base leading-relaxed pt-1 border-t border-brand-green/10 mx-5" dangerouslySetInnerHTML={{
                  __html: faq.a
                }} data-id="element-98" />
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <div className="text-center bg-brand-cream/50 p-8 rounded-3xl border border-brand-brown/5" data-id="element-99">
          <p className="text-2xl font-playfair italic text-brand-brown mb-6" data-id="element-100">
            Ya no hay excusas. Empezá hoy.
          </p>
          <CTAButton className="w-full md:w-auto md:px-10 text-xl py-4 shadow-[0_10px_30px_rgba(45,90,61,0.4)]" data-id="element-101">
            EMPEZAR AHORA POR $7.990 →
          </CTAButton>
        </div>
      </div>
    </section>;
}